import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Avatar from 'Components/Avatar'
import Modal from 'Components/Modal'
import Multiple from 'Components/Multiple'
import Search from 'Components/Search'
import ApiRequest from 'EurestoApi/ApiRequest'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Recherche from 'EurestoComponents/Recherche'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'
import FicheContact from '../Fiche/FicheContact'





const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  state = {
    key: Utils.getRandomNumber(),
    datas: [],
    data: {},
    contacts: [],
    datas_contact: [],
    dedupe: [],
    key_fiche: Utils.getRandomNumber(),
    relationsEtablissement: [],
    view_contact: undefined
  }

  columns = [
    {
      Header: () => <span style={{ cursor: 'not-allowed' }}><i className="EurestoPrimary--text ei-module_crm"
        aria-hidden="true" />x</span>,
      id: 'nb_lignes',
      sortable: false,
      accessor: 'nb_lignes',
      width: 20,
      Cell: row => {
        return (
          <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
            alignItems={'center'}>
            <b>{row.original.nb_lignes - (row.original.nb_relations > 1 && (row.original.nb_relations + 1) || 0)}</b>
          </Grid>
        )
      },
    },
    { Header: 'id', accessor: 'id', show: false },
    {
      Header:
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
          alignItems={'center'}>
          <b>Personne/Entité</b>
        </Grid>,
      accessor: 'libelle',
      minWidth: 130,
      Cell: row => {
        return (
          <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
            alignItems={'center'}>
            <b>{row.original.nom + (this.state.dedupe.indexOf('prenom') !== -1 && ((row.original.nom && row.original.prenom && ' ') + row.original.prenom) || '')}</b>
          </Grid>
        )
      },
    },
  ]

  unlockContact = async _ => {
    const datas = this.state.datas
    if ((datas || []).length > 0) {
      await Promise.all(datas.map(async c => {
        const result = await ApiRequest(project.api + 'crm', {
          action: 'unlock',
          requete: 'contact',
          id: c.id
        }, { showAlertError: false })
      }))
    }
  }

  // async componentWillUnmount () {
  //   await this.unlockContact()
  // }

  onClickContact = async (row) => {
    const recherche = this.state.dedupe.map(champ => ({
      champ: champ,
      valeur: row[champ],
      operation: 'like',
      join: false
    }))

    recherche.push({
      champ: 'type_contact_id',
      valeur: [3, 4],
      operation: 'contain',
      non: true
    })

    const r = await ApiRequest(project.api + 'crm', {
      requete: 'client',
      action: 'list',
      recherche: recherche,
      information_tiers: true,
      coordonnees: true,
      relations: true,
      entite: true,
      all_info_contact: true
    }, { showAlertError: false })
    if (r && r.results && r.results.length > 0) {
      try {
        await Promise.all(r.results.map(async c => {
          const result = await ApiRequest(project.api + 'crm', {
            action: 'lock',
            requete: 'contact',
            id: c.id
          }, { showAlertError: false })

          if (!result || result.code !== 1) {
            throw Error('Une personne est déjà en cours de modification d\'une des fiches, vous ne pouvez la modifier (' + (c.libelle) + ' #' + c.id + ')')
          }
          if (User.TypeAccess.get(Constants.access.GROUPE)) {
            const relationsEtablissement = await ApiRequest(project.api + 'crm', {
              action: 'get_relations',
              requete: 'client',
              id: this.state.contact.id
            }, { showAlertError: false })
          }
        }))
        const data = EurestoClone(r.results[0])
        if (r && r.results) {
          this.setState({
            datas: r.results,
            data: data,
            datas_contact: [data.id],
            key_fiche: Utils.getRandomNumber(),
          })
        }
      } catch (err) {
        alert(err)
      }
    }
  }

  handleSaveContact = async contact => {
    // await this.unlockContact()

    this.setState({
      key: Utils.getRandomNumber(),
      datas: [],
      data: {},
      contacts: [],
      datas_contact: [],
      key_fiche: Utils.getRandomNumber(),
      relationsEtablissement: [],
      view_contact: undefined
    })
  }

  onDedupeChange = async (data) => {
    // await this.unlockContact()
    this.setState({
      dedupe: data,
      datas: [],
      data: {},
      contacts: [],
      datas_contact: [],
      key_fiche: Utils.getRandomNumber(),
      relationsEtablissement: [],
      view_contact: undefined
    })
  }

  contactAdresse = (contact) => {
    return contact.adresse1 + ((contact.adresse1 && contact.adresse2) && ' ')
      + contact.adresse2 + ((contact.adresse2 || contact.adresse3) && ' ')
      + contact.adresse3 + ((contact.adresse3 || contact.cp) && ' ')
      + contact.cp + ((contact.cp || contact.ville) && ', ')
      + contact.ville
  }

  onClick = (data, name) => {
    this.setState((state) => ({
      data: {
        ...state.data,
        [name]: data
      },
      key_fiche: Utils.getRandomNumber()
    }))
  }

  onClickAdresse = (contact) => _ => {
    const { data } = this.state
    data.adresse1 = contact.adresse1
    data.adresse2 = contact.adresse2
    data.adresse3 = contact.adresse3
    data.cp = contact.cp
    data.ville = contact.ville

    this.setState({
      data: data,
      key_fiche: Utils.getRandomNumber()
    })
  }

  onAddRemoveContactDedupe = (id) => _ => {
    const { datas_contact } = this.state
    let data = this.state.data
    let datas = this.state.datas
    const i = datas_contact.indexOf(id)
    if (i !== -1) {
      datas_contact.splice(i, 1)
      if (data.id === id) {
        if (datas_contact.length === 0) {
          data = {}
        } else {
          data.id = datas_contact[0]
        }
      }
    } else {
      if (datas_contact.length === 0) {
        data = EurestoClone(datas.find(d => d.id === id))
      }
      datas_contact.push(id)
    }
    this.setState({
      data: data,
      datas_contact: datas_contact,
      key_fiche: Utils.getRandomNumber()
    })
  }

  openModal = (id) => _ => {
    const { datas } = this.state
    this.setState({
      view_contact: datas.find(d => d.id === id)
    })
  }

  entiteHeader = header => {
    return <Grid
      item
      style={{
        minWidth: header.width || 200,
        width: header.width || 200,
        margin: 0,
        padding: '0px 5px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textAlign: 'left'
      }}
    >{header.label}</Grid>
  }

  entiteColumn = (contact, header) => {
    const column = header.column
    return <Grid
      item
      onClick={() => contact[column] !== this.state.data[column] && this.onClick(contact[column], column)}
      className={'' + (contact[column] === this.state.data[column] && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
      style={{
        minWidth: header.width || 200,
        width: header.width || 200,
        margin: 0,
        padding: '0px 5px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textAlign: 'left'
      }}
    >{
        (column === 'anniversaire' || column === 'marie')
        && <DataComponent
          disabled={true}
          type={Constants.typeSaisie.Date}
          data={contact[column]}
          defineData={true}
        />
        || contact[column]
      }</Grid>
  }

  headerEntite = {
    1: [
      { label: 'Date de mariage', column: 'marie', width: 140 },
      { label: 'Date d\'anniversaire', column: 'anniversaire', width: 140 },
      { label: 'Numéro sécu', column: 'numero_secu' },
      { label: 'Lieu naissance', column: 'lieu_naissance' },
      { label: 'Siteweb', column: 'siteweb' },
      { label: 'Plafond encours', column: 'plafond_encours' },
    ],
    2: [
      { label: 'Siret', column: 'siret' },
      { label: 'Code NAF/APE', column: 'code_naf_ape' },
      { label: 'TVA intra', column: 'tva_intra' },
      { label: 'Iban', column: 'iban' },
      { label: 'BIC', column: 'bic' },
      { label: 'Siteweb', column: 'siteweb' },
      { label: 'Raison sociale', column: 'designation_juridique' },
    ]
  }

  render() {
    const { data, datas_contact } = this.state

    let relations = []
    let information_tiers = {}
    let adresses = []
    let coordonnees = [];
    (datas_contact || []).map(id => {
      const contact = this.state.datas.find(d => d.id === id)
      if (contact && contact.relations && contact.relations.length > 0) {
        relations = [
          ...relations,
          ...contact.relations,
        ]
      }
      if (contact && contact.information_tiers && Object.keys(contact.information_tiers).length > 0) {
        information_tiers = [
          ...contact.information_tiers,
          ...information_tiers
        ]
      }
      if (contact && contact.adresses && contact.adresses.length > 0) {
        adresses = [
          ...adresses,
          ...contact.adresses,
        ]
      }
      if (contact && contact.coordonnees && contact.coordonnees.length > 0) {
        coordonnees = [
          ...coordonnees,
          ...contact.coordonnees,
        ]
      }
    })

    if ((datas_contact || []).length > 0) {
      data.relations = relations
      data.information_tiers = information_tiers
      data.adresses = adresses
      data.coordonnees = coordonnees
    }

    return <Grid container style={{ margin: 0, padding: 0, paddingTop: 5 }} spacing={0} wrap={'nowrap'}>
      <Grid item xs={2} style={{ margin: 0, padding: 0 }}>
        <Grid container style={{ margin: 0, padding: 0 }} spacing={0} direction={'column'}>
          <Search background={'transparent'} defaultSearch={this.props.defaultSearch} path={'crm'}
            requete={'client'}
            style={{ fontSize: 12, padding: 2, right: 15, position: 'absolute', top: 7, zIndex: 100 }}
            search={'client_' + (this.state.key + '-') + User.Entite.get().id}>
            <SearchClient key={this.state.key + '_client_seach'} dedupe={this.state.dedupe} forceSearch={true}
              onDedupeChange={this.onDedupeChange} />
          </Search>

          <Recherche
            key={this.state.key + '_client_datagrid_seach'}
            style={{ maxHeight: User.CalculHeight.getHeightWanted(500) }}
            view={'list'}
            onClick={async (row) => {
              // await this.unlockContact()
              this.setState({
                datas: [],
                data: {},
                contacts: [],
                datas_contact: [],
                key_fiche: Utils.getRandomNumber(),
                relationsEtablissement: [],
                view_contact: undefined
              }, () => this.onClickContact(row))
            }}
            columns={this.columns}
            search={'client_' + (this.state.key + '-') + User.Entite.get().id}
          />
        </Grid>
      </Grid>

      <Grid item xs={10} style={{ margin: '0 10px', padding: 0, position: 'relative' }}>
        <Paper>
          <Grid className={'cursor-pointer'} container
            style={{
              margin: 0,
              padding: 0,
              paddingBottom: 10,
              overflow: 'auto',
            }}
            direction={'column'}
            spacing={0}>
            <Grid className={'cursor-pointer'} container
              style={{
                margin: 0,
                padding: 0,
                paddingBottom: 5,
                position: 'relative',
                borderBottom: '1px solid #E9E9E9',
                minWidth: '100%',
                width: 'auto',
                boxShadow: '0 3px 4px 0 rgba(0,0,0,0.2), 0 3px 4px 0 rgba(0,0,0,0.19)'
              }}
              spacing={0} wrap={'nowrap'}>
              <Grid item style={{
                minWidth: 30,
                width: 30,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}><i className={'ei-commun_visualiser EurestoPrimary--text'} /></Grid>
              <Grid className={'cursor-pointer'} item style={{
                minWidth: 30,
                width: 30,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}
                onClick={() => {
                  if (this.state.datas_contact.length === (this.state.datas || []).length) {
                    (this.state.datas || []).map(contact => {
                      this.onAddRemoveContactDedupe(contact.id)()
                    })
                  } else {
                    (this.state.datas || []).filter(contact => this.state.datas_contact.indexOf(contact.id) === -1).map(contact => {
                      this.onAddRemoveContactDedupe(contact.id)()
                    })
                  }
                }}
              ><i className={'ei-commun_valider EurestoPrimary--text'} /></Grid>
              <Grid item style={{
                minWidth: 100,
                width: 100,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Photo</Grid>
              <Grid item style={{
                minWidth: 100,
                width: 100,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Entité</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Nom</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Prénom</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Qualité</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Civilité</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Email</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Fixe</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Portable</Grid>
              <Grid item style={{
                minWidth: 400,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Adresse</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Type client</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textWrap: 'no-wrap',
                textAlign: 'left'
              }}>Pays</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Langue</Grid>
              <Grid item style={{
                minWidth: 200,
                width: 200,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Nationnalité</Grid>
              {User.TypeAccess.get(Constants.access.GROUPE) && <Grid xs item style={{
                minWidth: 100,
                width: 100,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Public</Grid>}
              {!User.TypeAccess.get(Constants.access.EURESTO) && <Grid xs item style={{
                minWidth: 100,
                width: 100,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Confidentiel</Grid>}
              <Grid xs item style={{
                minWidth: 150,
                width: 150,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Esclus E-mailing</Grid>
              <Grid xs item style={{
                minWidth: 150,
                width: 150,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Eclus Mailing</Grid>
              <Grid xs item style={{
                minWidth: 100,
                width: 100,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Exclus SMS</Grid>
              <Grid xs item style={{
                minWidth: 100,
                width: 100,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>VIP</Grid>
              <Grid xs item style={{
                minWidth: 100,
                width: 100,
                margin: 0,
                padding: '0px 5px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textAlign: 'left'
              }}>Image</Grid>
              {
                (this.state.datas || []).filter(d => this.state.datas_contact.indexOf(d.id) !== -1).findIndex(d => d.entite === 1) !== -1
                && this.headerEntite['1'].map(h => (
                  this.entiteHeader(h)
                )) || ''
              }
              {
                (this.state.datas || []).filter(d => this.state.datas_contact.indexOf(d.id) !== -1).findIndex(d => d.entite === 2) !== -1
                && this.headerEntite['2'].map(h => (
                  this.entiteHeader(h)
                )) || ''
              }
            </Grid>
            {
              (this.state.datas || []).map(contact => {
                return (
                  <Grid className={'cursor-pointer'} container
                    style={{
                      margin: 0,
                      padding: 0,
                      position: 'relative',
                      borderBottom: '1px solid #E9E9E9',
                      width: 'auto',
                    }}
                    spacing={0} wrap={'nowrap'}>
                    <Grid item
                      onClick={this.openModal(contact.id)}
                      className={'cursor-pointer'}
                      style={{
                        minWidth: 30,
                        width: 30,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}><i className={'ei-commun_visualiser EurestoSecondary--text'} /></Grid>

                    <Grid item
                      onClick={this.onAddRemoveContactDedupe(contact.id)}
                      className={'cursor-pointer'}
                      style={{
                        minWidth: 30,
                        width: 30,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{(datas_contact || []).indexOf(contact.id) !== -1 &&
                        <i className={'ei-commun_valider EurestoSecondary--text'} /> ||
                        <i className={'ei-commun_fermer EurestoError--text'} />}</Grid>
                    <Grid item
                      onClick={() => contact.media_id !== this.state.data.media_id && this.onClick({
                        media_id: contact.media_id,
                        media_lien: contact.media_lien
                      }, 'picture')}
                      className={'' + (contact.media_id === this.state.data.media_id && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>
                      <Avatar
                        src={contact.media_lien}
                        style={{ width: 60, height: 60, padding: 5 }} />
                    </Grid>
                    <Grid item
                      onClick={() => contact.entite !== this.state.data.entite && this.onClick(contact.entite, 'entite')}
                      className={contact.entite === this.state.data.entite && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer'}
                      style={{
                        minWidth: 100,
                        width: 100,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.entite === 1 &&
                        <span className={'fa ei-crm_physique EurestoPrimary--text'} />
                        ||
                        <span className={'fa ei-crm_morale EurestoPrimary--text'} />}
                    </Grid>
                    <Grid item
                      onClick={() => contact.nom !== this.state.data.nom && this.onClick(contact.nom, 'nom')}
                      className={contact.nom === this.state.data.nom && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer'}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.nom}</Grid>
                    <Grid item
                      onClick={() => contact.prenom !== this.state.data.prenom && this.onClick(contact.prenom, 'prenom')}
                      className={'' + (contact.prenom === this.state.data.prenom && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.prenom}</Grid>
                    <Grid item
                      onClick={() => contact.qualite_id !== this.state.data.qualite_id && this.onClick(contact.qualite_id, 'qualite_id')}
                      className={'' + (contact.qualite_id === this.state.data.qualite_id && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.qualite_id && Data.get(Constants.module.CRM, Constants.donnee.qualite, { id: contact.qualite_id }).libelle}</Grid>
                    <Grid item
                      onClick={() => contact.civilite_id !== this.state.data.civilite_id && this.onClick(contact.civilite_id, 'civilite_id')}
                      className={'' + (contact.civilite_id === this.state.data.civilite_id && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.civilite_id && Data.get(Constants.module.COMMUN, Constants.donnee.civilite, { id: contact.civilite_id }).libelle}</Grid>
                    <Grid item
                      onClick={() => contact.email !== this.state.data.email && this.onClick(contact.email, 'email')}
                      className={'' + (contact.email === this.state.data.email && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.email}</Grid>
                    <Grid item
                      onClick={() => contact.fixe !== this.state.data.fixe && this.onClick(contact.fixe, 'fixe')}
                      className={'' + (contact.fixe === this.state.data.fixe && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.fixe}</Grid>
                    <Grid item
                      onClick={() => contact.portable !== this.state.data.portable && this.onClick(contact.portable, 'portable')}
                      className={'' + (contact.portable === this.state.data.portable && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.portable}</Grid>
                    <Grid item
                      onClick={this.onClickAdresse(contact)}
                      className={'' + (this.contactAdresse(contact) === this.contactAdresse(this.state.data) && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 400,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{this.contactAdresse(contact)}</Grid>
                    <Grid item
                      onClick={() => contact.type_client_id !== this.state.data.type_client_id && this.onClick(contact.type_client_id, 'type_client_id')}
                      className={'' + (contact.type_client_id === this.state.data.type_client_id && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.type_client_id && Data.get(Constants.module.CRM, Constants.donnee.type_client, { id: contact.type_client_id }).libelle}</Grid>
                    <Grid item
                      onClick={() => contact.pays_id !== this.state.data.pays_id && this.onClick(contact.pays_id, 'pays_id')}
                      className={'' + (contact.pays_id === this.state.data.pays_id && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textWrap: 'no-wrap',
                        textAlign: 'left'
                      }}>{contact.pays_id && Data.get(Constants.module.COMMUN, Constants.donnee.pays, { id: contact.pays_id }).libelle}</Grid>
                    <Grid item
                      onClick={() => contact.langue_id !== this.state.data.langue_id && this.onClick(contact.langue_id, 'langue_id')}
                      className={'' + (contact.langue_id === this.state.data.langue_id && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.langue_id && Data.get(Constants.module.COMMUN, Constants.donnee.langue, { id: contact.langue_id }).libelle}</Grid>
                    <Grid item
                      onClick={() => contact.nationalite_id !== this.state.data.nationalite_id && this.onClick(contact.nationalite_id, 'nationalite_id')}
                      className={'' + (contact.nationalite_id === this.state.data.nationalite_id && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 200,
                        width: 200,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.nationalite_id && Data.get(Constants.module.COMMUN, Constants.donnee.pays, { id: contact.nationalite_id }).nationnalite}</Grid>
                    {User.TypeAccess.get(Constants.access.GROUPE) &&
                      <Grid xs item
                        onClick={() => contact.public !== this.state.data.public && this.onClick(contact.public, 'public')}
                        className={'' + (contact.public === this.state.data.public && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                        style={{
                          minWidth: 100,
                          width: 100,
                          margin: 0,
                          padding: '0px 5px',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textAlign: 'left'
                        }}>{contact.public === false && 'Faux' || 'Vrai'}
                      </Grid>}
                    {!User.TypeAccess.get(Constants.access.EURESTO) &&
                      <Grid xs item
                        onClick={() => contact.confidentiel !== this.state.data.confidentiel && this.onClick(contact.confidentiel, 'confidentiel')}
                        className={'' + (contact.confidentiel === this.state.data.confidentiel && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                        style={{
                          minWidth: 100,
                          width: 100,
                          margin: 0,
                          padding: '0px 5px',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textAlign: 'left'
                        }}>{contact.confidentiel && 'Vrai' || 'Faux'}
                      </Grid>}
                    <Grid xs item
                      onClick={() => contact.exclusEmailing !== this.state.data.exclusEmailing && this.onClick(contact.exclusEmailing, 'exclusEmailing')}
                      className={'' + (contact.exclusEmailing === this.state.data.exclusEmailing && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 150,
                        width: 150,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.exclusEmailing && 'Vrai' || 'Faux'}
                    </Grid>
                    <Grid xs item
                      onClick={() => contact.exclusMailing !== this.state.data.exclusMailing && this.onClick(contact.exclusMailing, 'exclusMailing')}
                      className={'' + (contact.exclusMailing === this.state.data.exclusMailing && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 150,
                        width: 150,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.exclusMailing && 'Vrai' || 'Faux'}
                    </Grid>
                    <Grid xs item
                      onClick={() => contact.exclusSms !== this.state.data.exclusSms && this.onClick(contact.exclusSms, 'exclusSms')}
                      className={'' + (contact.exclusSms === this.state.data.exclusSms && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 100,
                        width: 100,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.exclusSms && 'Vrai' || 'Faux'}
                    </Grid>
                    <Grid xs item
                      onClick={() => contact.vip !== this.state.data.vip && this.onClick(contact.vip, 'vip')}
                      className={'' + (contact.vip === this.state.data.vip && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 100,
                        width: 100,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.vip}
                    </Grid>
                    <Grid xs item
                      onClick={() => contact.media_id !== this.state.data.media_id && this.onClick(contact.media_id, 'media_id')}
                      className={'' + (contact.media_id === this.state.data.media_id && 'EurestoSecondary EurestoPrimary--text cursor-not-allowed' || 'cursor-pointer')}
                      style={{
                        minWidth: 100,
                        width: 100,
                        margin: 0,
                        padding: '0px 5px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textAlign: 'left'
                      }}>{contact.media_id}
                    </Grid>
                    {
                      (this.state.datas || []).filter(d => this.state.datas_contact.indexOf(d.id) !== -1).findIndex(d => d.entite === 1) !== -1
                      && this.headerEntite['1'].map(h => (
                        this.entiteColumn(contact, h)
                      )) || ''
                    }
                    {
                      (this.state.datas || []).filter(d => this.state.datas_contact.indexOf(d.id) !== -1).findIndex(d => d.entite === 2) !== -1
                      && this.headerEntite['2'].map(h => (
                        this.entiteColumn(contact, h)
                      )) || ''
                    }
                  </Grid>
                )
              })
            }
          </Grid>
          {this.state.data && Object.keys(this.state.data).length > 0 &&
            <FicheContact dedupe={this.state.datas_contact}
              handleSaveContact={this.handleSaveContact}
              key={this.state.key_fiche} doNotLockUnlock={true}
              typeaction="add"
              data={this.state.data} />}
        </Paper>
      </Grid>
      {
        this.state.view_contact &&
        <Modal
          fromModal={true} open={this.state.view_contact !== undefined} onClose={this.openModal(0)} grid={{ xs: 10 }}>
          <EurestoDiv
            buttonsRight={[{
              icon: ' ei-commun_fermer',
              className: 'EurestoError--text EurestoText',
              cb: this.openModal(0)
            }]}
            style={{
              margin: 0,
              padding: 10,
              maxHeight: User.CalculHeight.getHeightWanted(40),
              height: User.CalculHeight.getHeightWanted(40),
              overflowY: 'auto'
            }}>
            <FicheContact doNotLockUnlock={true} modalHeight={50} key={this.state.key_fiche + '_modal'} showInfo={true}
              typeaction="update"
              data={this.state.view_contact} />
          </EurestoDiv>
        </Modal>
      }
    </Grid>
  }
}

class SearchClient extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      dedupe: props.dedupe && props.dedupe.length > 0 && props.dedupe || ['nom'],
    }
  }

  componentDidMount = () => {
    this.props.forceSearch && this.search()
  }

  search = (dedupe = this.state.dedupe) => {
    const search = {}
    dedupe.map(d => {
      search['_' + d] = 1
      search['_' + d + '_'] = false
    })
    search.type_contact_id = [3, 4]
    search.type_contact_id_non = true
    this.setState({
      dedupe: dedupe,
    }, () => {
      this.props.searching && ((dedupe && dedupe.length > 1 && this.props.searching(search, { dedupe })) || this.props.searching({}, []))
      this.props.onDedupeChange && this.props.onDedupeChange(dedupe)
    })
  }

  searchClient = async (data) => {
    let dedupe = data
    if (dedupe.length === 0) {
      dedupe = ['nom']
    }
    this.search(dedupe)
  }

  render() {
    return (
      <Grid container spacing={0} style={{ margin: 0, padding: 0 }} justify={'flex-start'} alignItems={'stretch'}
        direction={'column'}>
        <Multiple
          onChange={this.searchClient}
          value={this.state.dedupe}
          title={EurestoI18n.t('crm:Dédoublonner sur')}
          name="dedupe"
          options={[{
            value: 'nom',
            label: 'Nom',
          }, {
            value: 'prenom',
            label: 'Prénom',
          }, {
            value: 'email',
            label: 'E-mail',
          }, {
            value: 'fixe',
            label: 'Fixe',
          }, {
            value: 'portable',
            label: 'Portable',
          }, {
            value: 'cp',
            label: 'CP',
          }, {
            value: 'ville',
            label: 'Ville',
          }, {
            value: 'qualite_id',
            label: 'Qualité',
          }, {
            value: 'type_client_id',
            label: 'Type client',
          },]}
        />
      </Grid>
    )
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Dedupe/index.js